import { useState, useRef, useEffect } from "react";
import styles from "./subscribtion.module.scss";
import Link from "next/link";
import { validateEmail } from "../../../utils/validate";
import { userSubscription } from "../../../pages/api/api";
import { HandySvg } from "handy-svg";
import { useRouter } from "next/router";
import getCommonLocales from "../../../locales/locales_common";

function Subscription() {
  const router = useRouter();
  const { locale } = router;
  const dictionary = getCommonLocales(locale);
  const [modalIsShown, setModalIsShown] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [resMessage, setResMessage] = useState("");
  const modalRef = useRef();
  const btnRef = useRef();

  useEffect(() => {
    const clickHandler = (e) => {
      if (
        !e.target.matches(".modal") &&
        !e.target.matches(".btn *") &&
        !e.target.matches(".modal *")
      ) {
        setModalIsShown(false);
      }
    };
    document.body.addEventListener("mousedown", clickHandler);
    return () => {
      document.body.removeEventListener("mousedown", clickHandler);
    };
  }, []);

  const submitHandler = async (e) => {
    e.preventDefault();
    const data = {
      email: userInput,
    };
    let res = await userSubscription(data);

    if (res.status >= 200 && res.status < 300) {
      setResMessage("Your form has been submitted successfully. Thank You!");
      setIsChecked(false);
      setUserInput("");
    } else {
      setResMessage(res.data.message);
      setIsChecked(false);
      setUserInput("");
    }

    setTimeout(() => {
      setResMessage("");
      setModalIsShown(false);
    }, 3000);
  };

  return (
    <div className={styles.container}>
      <div ref={modalRef} className={` modal ${styles.modal} ${modalIsShown && styles.open}`}>
        <div className={styles.content}>
          <div className={styles.info}>
            <h5 className={styles.title}>{dictionary["Would you like to subscribe to BgRem blog?"] || "Would you like to subscribe to BgRem blog?"}</h5>
            <p className={styles.text}>{dictionary["Stay up-to-date with our news"] || "Stay up-to-date with our news"}</p>
          </div>
          {!resMessage ? (
            <form onSubmit={submitHandler} className={styles.form}>
              <input
                value={userInput}
                onChange={(e) => setUserInput(e.target.value.toLowerCase())}
                className={styles.input}
                type="text"
                placeholder={dictionary["Your Email"] || "Your Email"}
              />
              <label
                onClick={() => setIsChecked(!isChecked)}
                className={isChecked ? styles.checked : styles.label}
                htmlFor="checkbox"
              >
                <input
                  className={styles.checkbox}
                  type="checkbox"
                  name="checkbox"
                  checked={isChecked}
                  onChange={() => setIsChecked(true)}
                />
                {dictionary["I accept BgRem Privacy Policy"] || "I accept BgRem Privacy Policy"}
              </label>
              <button
                disabled={!validateEmail(userInput) || !isChecked}
                className={styles["modal-btn"]}
                type="submit"
                value="Subscribe"
              >
                {dictionary["subscribe"] || "Subscribe"}
              </button>
            </form>
          ) : (
            <div className={styles.response}>{resMessage}</div>
          )}
        </div>
      </div>
      <div className={styles.subscription}>
        <Link href="/" className={styles.logo}>
          <HandySvg src={"/header/color_header_logo_blog.svg"} width={100} height={32} className={styles.logo} />
        </Link>
        <div className={styles["subscription-text"]}>
          Publication by{" "}
          <Link className={styles.link} href="/">BgRem</Link>{" "}
          <span className={styles["additional-text"]}>about creativity and design</span>
        </div>
        <button
          ref={btnRef}
          onClick={() => setModalIsShown(true)}
          className={`btn ${styles.btn}`}
        >
          <span>Subscribe </span>
          <span className={styles["additional-btn"]}>to our newsletter</span>
        </button>
      </div>
    </div>
  );
}

export default Subscription;
